import httpClient from "@/config/axios";

type GetDailyShiftProps = {
  office_id: string;
  group_id: string;
  year: number;
  month: number;
};

export interface DailyShiftMonthSummary {
  D_count: number;
  E_count: number;
  N_count: number;
  M_count: number;
  D_count_max: number;
  E_count_max: number;
  N_count_max: number;
  M_count_max: number;
  max_enabled: boolean;
}

export interface DailyShiftDate {
  D_count: number[];
  E_count: number[];
  N_count: number[];
  M_count: number[];
  D_count_max: number[];
  E_count_max: number[];
  N_count_max: number[];
  M_count_max: number[];
}

export interface DailyShiftResponse {
  office_id: string;
  group_id: string;
  year: number;
  month: number;
  month_summary: DailyShiftMonthSummary;
  date: DailyShiftDate;
  max_enabled: boolean;
}

export interface DailyShiftReplaceRequest {
  office_id: string;
  group_id: string;
  year: number;
  month: number;
  date: {
    D_count: number[];
    E_count: number[];
    N_count: number[];
    M_count?: number[];
    D_count_max?: number[];
    E_count_max?: number[];
    N_count_max?: number[];
    M_count_max?: number[];
  };
  max_enabled?: boolean;
  apply_globally?: boolean;
  month_summary?: Partial<DailyShiftMonthSummary>;
}

export function parseManpowerFromApi(data: DailyShiftResponse) {
  const monthly: Record<string, number> = {};

  for (const [key, value] of Object.entries(data.month_summary)) {
    if (key === "max_enabled") continue;

    if (key.endsWith("_count_max")) {
      const numValue = Number(value);
      if (Number.isFinite(numValue)) {
        monthly[key.replace(/_count_max$/, "_max")] = numValue;
      }
    } else if (key.endsWith("_count")) {
      const numValue = Number(value);
      if (Number.isFinite(numValue)) {
        monthly[key.replace(/_count$/, "")] = numValue;
      }
    }
  }

  const daily: Record<string, number[]> = {};

  for (const [key, value] of Object.entries(data.date)) {
    if (!Array.isArray(value)) continue;

    if (key.endsWith("_count_max")) {
      daily[key.replace(/_count_max$/, "_max")] = value.map((v) => Number(v));
    } else if (key.endsWith("_count")) {
      daily[key.replace(/_count$/, "")] = value.map((v) => Number(v));
    }
  }

  return {
    monthly,
    daily,
    useMax: Boolean(data.max_enabled ?? data.month_summary?.max_enabled),
  };
}

export default function getDailyShift({
  office_id,
  group_id,
  year,
  month,
}: GetDailyShiftProps) {
  const url = `/daily-shift?office_id=${office_id}&group_id=${group_id}&year=${year}&month=${month}`;
  console.log("[getDailyShift] GET", {
    url,
    office_id,
    group_id,
    year,
    month,
  });

  return httpClient.get<DailyShiftResponse>(url).then((data) => {
    console.log("D length :", data.date.D_count.length);
    console.log("data:", data);
    return data;
  });
}
